import { useMemo } from 'react'

import { useStars } from './useStars'

export const useStarById = ({ starId }: { starId: string }) => {
  const { stars } = useStars()

  const star = useMemo(() => {
    return stars.find((star) => star.id === starId)
  }, [starId, stars])

  return { star }
}
